module.exports = __webpack_public_path__ + "media/images/vip-events-37410c3e2741951bbfe576006f6b29b3.svg";